import { render, staticRenderFns } from "./CsAsignacionContableForm.vue?vue&type=template&id=37169125"
import script from "./CsAsignacionContableForm.vue?vue&type=script&lang=js"
export * from "./CsAsignacionContableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports